export default __webpack_public_path__ + "static/media/ca-4-rMAX.ca2fe087.avif";